<template>

  <div class="container">
    <div v-show="state === 0" class="intro-block">
      <div class="image-block"></div>
      <div class="text-block">
        <div class="muted">Тест</div>
        <h1>Какой пенсионер из тебя получится?</h1>
        <p>Модная борода и стаканчик кофе на вынос в руке или уютный ватник на плечах и хозяйственная сумка-тележка в
          качестве аксессуара? Пройди тест и узнай, каким пенсионером ты будешь!</p>
        <button v-on:click="nextState"
                onclick="ga('button', 'click', 'start_test')"
        >НАЧАТЬ ТЕСТ</button>
      </div>
    </div>
    <div v-show="state === 1" class="question-block " :class="questionClass">

      <div class="question">
        <div class="counter">{{counterText}}</div>
        <div class="question-text">{{questionText}}</div>
        <div class="answers">
          <div class="answer" v-for="answer in questions[questionIndex].answers" :data-value="answer.value"
               :data-f1="answer.flag1" :data-f2="answer.flag2"
               v-on:click="response(answer.value,answer.flag1,answer.flag2)">{{answer.text}}
          </div>
        </div>
      </div>
    </div>
    <div v-show="state === 2" class="result-block" :class="resultClass">
      <div class="result-intro">
        <div class="result-text">
          <div class="muted">Результат</div>
          <h1>{{quizResult.title}}<sup v-show="showStar === true">*</sup></h1>
          <p v-html="quizResult.text"></p>
          <div class="sharing">
            <a target="_blank"
               v-bind:href="'https://vk.com/share.php?url=http://npfsberbankatest.lenta.ru/result'+quizResult.id+'.html'"
               @click="shareClick('VK')">
              <i class="icon-vkontakte"></i>
            </a>
            <a @click="shareClick('TW')"
               v-bind:href="'https://twitter.com/intent/tweet?url=http://npfsberbankatest.lenta.ru/result'+quizResult.id+'.html'"
               target="_blank">
              <i class="icon-twitter"></i>
            </a>
            <a
              v-bind:href="'https://www.facebook.com/dialog/share?app_id=1458967624164016&display=popup&href=http://npfsberbankatest.lenta.ru/result'+quizResult.id+'.html'"
              target="_blank" @click="shareClick('FB')">
              <i class="icon-facebook"></i>
            </a>
            <a
              v-bind:href="'https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=http://npfsberbankatest.lenta.ru/result'+quizResult.id+'.html'"
              target="_blank" @click="shareClick('OK')">
              <i class="icon-odnoklassniki"></i>
            </a>
          </div>
          <button v-on:click="startNewQuiz"
          onclick="ga('button', 'click', 'start_again')"

          ><i class="icon-cw-1"></i>Начать заново</button>
          <div class="bot-text">Узнай, как и в старости
            ни в чем себе не отказывать
          </div>
          <div class="arrow"></div>
        </div>
        <div class="sub-text">
          {{quizResult.subText}}
        </div>

      </div>
      <div class="result-content">
        <div class="block-1">
          <div class="w1">
            <h1><a style="text-decoration:underline" href="http://www.npfsberbanka.ru/ipp/?utm_campaign=&utm_source=rambler&utm_medium=cpm&utm_content=test_ipp">Индивидуальный пенсионный план (ИПП)</a> — это программа для удобного накопления на свою будущую пенсию, вне
              зависимости от государственной пенсионной системы.
            </h1>
            <p>
              То есть, в случае с обычной пенсией вам платит государство, в случае с ИПП – вы сами можете вносить
              деньги,
              согласно любому удобному для вас графику, например, 1 раз в 2 месяца. Иначе говоря – это ваши частные
              накопления на безбедный отдых.
            </p></div>
          <div class="muted">Калькулятор</div>
          <h1 class="center">
            Выбери свое будущее
          </h1>
        </div>
        <div class="calc-block">
          <div class="npf-page">
            <div class="npf-container">
              <div class="npf-ipp-calc _margin-bottom_50">
                <ipp-calculator-component data-confirm-link="http://www.npfsberbanka.ru/ipp/">
                  <div class="npf-loader npf-loader__root npf-loader_active">
                  </div>
                </ipp-calculator-component>
              </div>
            </div>
          </div>
        </div>
        <div class="faq">
          <div class="faq-item" v-for="(item, key, index) in faq" @click="toggleCollapsation(key)"
               :class="faqClass(key)">
            <h2>{{ item.q }}</h2>
            <div class="text" v-html="item.a"></div>
          </div>
        </div>
        <a href="http://www.npfsberbanka.ru/ipp/?utm_campaign=&utm_source=rambler&utm_medium=cpm&utm_content=test_knopka" class="logo"><img src="/static/img/bot-logo.png" alt="" width="240px" height="44"></a>
      </div>
    </div>

  </div>

</template>

<script>
  var questions = [
    {
      text: "Каким ты представляешь свой идеальный отпуск?",
      answers: [
        {text: 'Обширная развлекательная программа в шумной европейской столице с компанией друзей', value: 1},
        {text: 'Пропущу отпуск чтобы сэкономить или перенесу трудовую вахту на дачный участок', value: 0},
      ]
    },

    {
      text: "На волне очередного глобального финансового кризиса все кинулись тратить сбережения, Как ты поступишь со своими?",
      answers: [
        {text: 'Куплю одежду и гаджеты, которые давно хотел(', value: 0},
        {text: 'Вложу в перспективную криптовалюту!', value: 1},
      ]
    },

    {
      text: "От каких ежедневных мелких расходов ты готов(а) отказаться в пользу",
      answers: [
        {
          text: 'Готов(а) отказаться от утреннего каппучино в кофейне или иногда брать обед на работу из дома',
          value: 1
        },
        {text: 'Не готов(а) отказываться ни от чего, ведь комфорт и состоит из этих мелочей', value: 0},
      ]
    },

    {
      text: "На какой статье расходов ты не готов(а) экономить, вне зависимости от глобальных финансовых кризисов и приближающийся отпуск?",
      answers: [
        {text: 'Новые кроссовки', value: 1},
        {text: 'Бары и рестораны', value: 0},
      ]
    },

    {
      text: "Получается ли у тебя выполнять данные себе обещания — например, похудеть к лету или начать бегать после нового года?",
      answers: [
        {text: 'Нет, мой энтузиазм быстро заканчивается', value: 0},
        {text: 'Да, я стараюсь добиваться своей цели ', value: 1},
      ]
    },

    {
      text: "В интернете снова кто-то неправ. Твои действия?",
      answers: [
        {text: 'Всю ночь строчу гневные комментарии и собираю армию анонимов для масштабных кибер-разборок ', value: 0},
        {text: 'Будут всегда, не стоит тратить на них нервы ', value: 1},
      ]
    },

    {
      text: "Привык ли ты планировать свои финансы и вести домашнюю бухгалтерию? ",
      answers: [
        {text: 'Да', value: 20, flag1: true},
        {text: 'Нет', value: 0},
      ]
    },

    {
      text: "Есть ли у тебя банковские вклады?",
      answers: [
        {text: 'Да', value: 18, flag2: true},
        {text: 'Нет', value: 0},
      ]
    },

    {
      text: "Ты уже задумывался(ась) о возможных источниках дохода после выхода на пенсию?",
      answers: [
        {text: 'Да, ведь с годами время летит все быстрее ', value: 12},
        {text: 'Нет, я еще слишком молод(а)', value: 0},
      ]
    },

    {
      text: "Знаешь ли ты, как устроены негосударственные пенсионные фонды?",
      answers: [
        {text: 'Да, представляю, что это за инструмент', value: 10},
        {text: 'Нет, не в курсе, что это', value: 0},
      ]
    },


  ]
  var results = [
    {
      id: 1,
      title: "Ветеран культуры",
      text: "Бабушки и дедушки твоего типа много времени посвящает детям и внукам, но, прежде всего, уделяют внимание своим культурным и духовным потребностям <span class='desk'> и проводят годы заслуженного отдыха, имея почти безграничный доступ к любым новым знаниям и впечатлениям. Твои внуки знают, что на театральные премьеры всегда будут куплены лучшие билеты, ведь твое светское расписание составляется на три месяца вперед, а интерес к происходящему в мире не угасает никогда</span>."
    },
    {
      id: 2,
      title: "Old Fashion",
      text: "<span class='desk'>Ты — гордость детей и внуков, вечный(ая) герой(героиня) всех стрит-стайл блогов и муза светских фотографов, поэтому для тебя всегда была и остается важной возможность обновлять гардероб и поддерживать спортивную форму. </span>Твоя суперсопособность — умение принимать людей такими, какие они есть, при этом считая возможные недостатки всего лишь особенностями, подчеркивающими индивидуальность.\n",
      subText: "*Старый модник"
    },
    {
      id: 3,
      title: "Пожилой нормкорщик",
      text: "Бытовой комфорт и достаток для тебя будут всегда важнее новых ощущений и эмоций. Ты — редкий пример пенсионера(ки), к которому(ой) младшие члены семьи не просто прислушиваются, а буквально выстраиваются в очередь за житейским советом<span class='desk'>, который никогда не будет дан с позиции осуждения. Ты давно и успешно нашел(нашла) себя, и пока есть деньги на счету, жить сбалансированной жизнью по средствам, при этом не отказывая себе в излюбленном досуге</span>."
    },
    {
      id: 4,
      title: "Пенсионерская классика ",
      text: "В одежде ты предпочитаешь комфортную пенсионерскую классику, а проводить добрую половину дня любишь сидя на лавке у подъезда с коллегами-скамеечниками. <span class='desk'>Наблюдения за более активной частью населения ты снабжаешь советами и нравоучениями, а твое любимое развлечение — наблюдать лица прохожих, ошарашенных высокими нравственными требованиями, предъявляемыми тобой роду человеческому. </span>"
    },

  ]
  var faq = [
    {
      collapsed: false,
      q: "Ну это же для пенсионеров? Я-то еще молодой!",
      a: "Самое время побеспокоиться о своем будущем! Не забывайте, что пенсионная система России обеспечивает только минимальный прожиточный уровень (в среднем 13 000 руб. в месяц). И что вы на них купите в старости? Представьте, что вам придется отказаться от всего, к чему вы привыкли и так любите: чашка  любимого кофе, отпуск на  курорте, прогулки по новым местам. Не страшно? Поэтому, чем раньше начать копить, тем эффективней будет ваш индивидуальный пенсионный план. Начать можно с небольшой суммы, например с 500 рублей в месяц.",

    },
    {
      collapsed: false,
      q: "Допустим, вы меня заинтересовали. А что с доходностью?\n",
      a: "На практике средняя доходность НПФ превышает инфляцию и является одной из самых высоких на финансовых рынках. Также не забывайте про 13-процентный возврат подоходного налога при уплате взносов (но не более 120 000 рублей в год). То есть, если вы внесли 120 000 рублей в год, то 15 600 рублей можно вернуть через налоговую или через работодателя (подав заявление в бухгалтерию).\n" +
      "\n"
    },
    {
      collapsed: false,
      q: "А если со мной что-то (стучу по дереву) случится? Денежки тю-тю?\n",
      a: "Конечно, нет. Если с вами что-то случится (стучим в ответ), то наследники получают до 100% вложений и накопленного инвестиционного дохода в соответствии с Правилами Фонда.\n" +
      "\n"
    },
    {
      collapsed: false,
      q: "А не проще ли мне купить квартиру или копить деньги в банке?\n",
      a: "Квартиру купить? Ну на это сразу нужен мешок денег. У вас он есть? Что же до накоплений в банках, то, например, максимальный срок депозита около 3 лет (очень редко банки делают депозиты на 5 лет), и он хорош для целевого накопления на год или три вперед. К тому же по нему не предоставляется налоговый вычет, да и снимать его придется полностью, либо получать проценты (при этом основная сумма будет лежать в банке). А по пенсионному плану вы можете выбрать срочную выплату (5-20 лет), либо пожизненную, причем сумма выплат будет индексироваться ежегодно.\n" +
      "\n"
    },

    {
      collapsed: false,
      q: "Посоветуйте мне оптимальную стратегию накопления",
      a: 'Оптимальная стратегия для каждого своя, но общее направление может быть такое:<br>- внести первый взнос (от 1500 рублей)<br>- подключить автоплатеж на комфортную для вас сумму и каждый год увеличивать его на 10-30% (в зависимости от возможностей)<br>- каждый год получать налоговый вычет по ИПП и вносить его на свой пенсионный счет в виде единовременного взноса<br> - в случае получения доп. доходов (премия, гонорар и т.д.) при возможности вносить разовые платежи на пенсионный счет на комфортные для вас суммы Как видите все очень просто.\n' +
      '\n'
    },

    {
      collapsed: false,
      q: "Хорошо, куда идти за индивидуальным пенсионным планом?",
      a: "Оформить ИПП можно в отделениях Сбербанка или на сайте НПФ Сбербанка, для заключения договора на сайте нужно заполнить свои данные и уплатить первый взнос с помощью банковской карты. Так же на сайте можно подключить автоплатеж для пополнения своего пенсионного счета.\n" +
      "\n"
    },

  ]
  import VueHead from 'vue-head'

  export default {
    name: "quiz",
    data() {
      return {
        state: 0,
        questionIndex: 0,
        faq: faq,
        questions: questions,
        results: results,
        score: 0,
        flag1: false,
        flag2: false,

      }
    },
    components: {
      VueHead
    },
    head: {
      title: {
        inner: 'Викторина'
      },
      meta() {
        return [
          {p: 'og:title', c: this.quizResult.title},
          // {p: 'og:description', c: RESULTS[this.id]},
          {p: 'og:image', c: '/static/img/share/' + this.quizResult.id + ".png"},
          {p: 'og:site_name', c: ''},
        ]
      }
    },
    computed: {

      counterText: function () {
        return "Вопрос " + (this.questionIndex + 1) + " из " + this.questions.length;
      },
      questionText: function () {
        return this.questions[this.questionIndex].text
      },
      questionClass: function () {
        return "question-" + (this.questionIndex + 1);
      },
      resultClass: function () {
        return "result-" + (this.quizResult.id);
      },
      quizResult: function () {
        if (this.score >= 15 || (this.flag1 && this.flag2)) {
          return this.results[0];
        }
        if (this.score >= 10 || this.flag1) {
          return this.results[1];
        }
        if (this.score >= 5 || this.flag2) {
          return this.results[2];
        }
        return this.results[3];
      },
      showStar: function () {
        return this.quizResult.subText != undefined
      },
      vkShareLink: function () {
        return "https://vk.com/share.php?url=http://npfsberbankatest.lenta.ru/&title=Мой результат: " + this.quizResult.title + "&image=http://npfsberbankatest.lenta.ru/static/img/share/" + this.quizResult.id + ".png&noparse=true";
      }
    },
    methods: {
      faqClass(i) {
        return (this.faq[i].collapsed) ? "" : "collapsed";
      },
      toggleCollapsation(i) {
        this.faq[i].collapsed = !this.faq[i].collapsed;
      },
      shareClick(method) {
      },
      nextState() {
        this.state++;
      },
      response: function (value, f1, f2) {
        this.score += value;
        this.flag1 = (f1) ? f1 : this.flag1;
        this.flag2 = (f2) ? f2 : this.flag2;

        if ((this.questionIndex + 1) == this.questions.length) {
          this.nextState();
          return true;
        }
        else {
          this.questionIndex++;
        }


      },
      startNewQuiz: function () {
        this.questionIndex = 0;
        this.score = 0;
        this.flag1 = false;
        this.flag2 = false;
        this.state = 0;


      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/css/icons.css";

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  button {
    cursor: pointer;
    outline: 0
  }

  .container {
    width: 1000px;
    min-height: 667px;
    display: flex;
    .intro-block {
      width: 100%;
      height: 667px;
      position: relative;
      background-image: url("/static/img/intro-bg.jpg");
      .image-block {
        background-image: url("/static/img/intro-1.png");
        width: 994px;
        height: 399px;
        position: absolute;
        left: 0;
        bottom: 20px;
        z-index: 20;
      }
      .text-block {
        width: 637px;
        height: 323px;
        margin: 30px auto;
        background-color: #efefef;
        .muted {
          font-family: PTSans;
          color: #a39292;
          font-size: 16px;
          font-weight: 400;
          line-height: 25.23px;
          text-align: center;
          margin-top: 35px;
        }
        h1 {
          font-family: PTSerif;
          color: #353131;
          font-size: 30px;
          font-weight: 700;
          line-height: 25.23px;
          text-align: center;
          margin-top: 22px;
        }
        p {
          font-family: PTSerif;
          color: #535353;
          font-size: 18px;
          font-weight: 400;
          line-height: 30px;
          text-align: center;
          margin-top: 24px;
        }
        button {
          border: 0;
          border-radius: 5px;
          background-color: #ff9908;
          width: 179px;
          height: 52px;
          font-family: PTSans;
          color: #ffffff;
          font-size: 16px;
          font-weight: 400;
          line-height: 25.23px;
          text-align: center;
          display: block;
          margin: 0 auto;
          margin-top: 35px;
          z-index: 30;
          position: relative;
        }
      }
    }
    .result-block {
      width: 100%;
      .result-intro {
        height: 667px;
        position: relative;
        display: flex;
        background-color: white;
        background-repeat: no-repeat;
        color: black;
        .result-text {
          width: 570px;
          margin: 0 auto;
          margin-top: 40px;
          .muted {
            font-family: PTSans;
            font-size: 16px;
            font-weight: 400;
            line-height: 25.23px;
            text-align: center;
          }
          h1 {
            font-family: PTSerif;
            color: #353131;
            font-size: 30px;
            font-weight: 700;
            line-height: 25.23px;
            text-align: center;
            margin-top: 19px;
            sup {
              font-family: PTSerif;
              color: #9b9393;
              font-size: 24px;
              font-weight: 700;
              line-height: 25.23px;
              text-align: center;
            }
          }
          p, span {
            margin-top: 30px;
            font-family: PTSerif;
            color: #535353;
            font-size: 18px;
            font-weight: 400;
            line-height: 27px;
            text-align: center;
            span {
              color: #535353;

            }
          }
          button {
            border: 0;
            font-family: PTSans;
            color: #af8549;
            font-size: 16px;
            font-weight: 400;
            line-height: 25.23px;
            text-align: center;
            background: transparent;
            text-transform: uppercase;

            display: block;
            margin: 0 auto;
            margin-top: 30px;
            i {
              color: #af8549;
            }
          }
          .bot-text {
            font-family: PTSans;
            color: #956015;
            font-size: 16px; /* Приближение из-за подстановки шрифтов */
            font-weight: 400;
            line-height: 26.221px; /* Приближение из-за подстановки шрифтов */
            text-align: center;
            display: block;
            width: 215px;
            margin: 0 auto;
            margin-top: 40px;
          }
          .arrow {
            background-image: url("/static/img/arrow.png");
            width: 18px;
            height: 24px;
            background-size: contain;
            margin: 0 auto;
            margin-top: 30px;
          }

        }
        .sub-text {
          font-family: PTSerif;
          color: gray;
          font-size: 11px;
          font-weight: 700;
          line-height: 25.23px;
          text-align: center;
          position: absolute;
          right: 10px;
          bottom: 10px;
          width: 100px;
        }
      }
      &.result-1 {
        .result-intro {
          background-image: url("/static/img/results/result-1.jpg");
          .result-text {
            margin-top: 40px;
          }
          .muted {
            color: #796060 !important;

          }
          h1 {
            color: white
          }
          p {
            color: white
          }
          .sub-text {
            color: #a58a7f !important;
          }
          .bot-text {
            color: #b6a58c;
          }
          button {
            color: #af8549;

          }
          .arrow {
            background-image: url("/static/img/arrow-1.png");
          }
        }
      }
      &.result-2 {
        .result-intro {
          background-image: url("/static/img/results/result-2.jpg");
          .muted {
            color: #a39292 !important;
          }
          .sub-text {
            color: #a58a7f !important;
          }
          button {
            color: #af8549;

          }
          p {
            margin-top: 10px;
          }
          h1 {
            margin-top: 10px;
          }
        }
      }
      &.result-3 {
        .result-intro {
          background-image: url("/static/img/results/result-3.jpg");
          .muted {
            color: #a39292 !important;
          }
          .sub-text {
            color: #a58a7f !important;
          }
          .bot-text {
            margin-top: 30px;
          }
          button {
            color: #af8549;

          }
          p {
            width: 90%;
            display: block;
            margin-left: auto;
            margin-right: auto;
          }

        }
      }
      &.result-4 {
        .result-intro {
          background-image: url("/static/img/results/result-4.jpg");
          .muted {
            color: #a39292 !important;
          }
          .sub-text {
            color: #a58a7f !important;
          }
          button {
            color: #af8549;

          }
          .bot-text {
            margin-top: 70px;
          }
        }
      }

    }
    .question-block {
      width: 100%;
      height: 667px;
      position: relative;
      background: #9de6fe;
      .question {
        width: 490px;
        margin-top: 180px;
        margin-left: 95px;
        .counter {
          font-family: PTSans;
          color: #506171;
          font-size: 16px;
          font-weight: 400;
          line-height: 25.23px;
          text-align: center;
        }
        .question-text {
          font-family: PTSerif;
          color: #353131;
          font-size: 26px;
          font-weight: 700;
          line-height: 25px;

          margin: 0 auto;
          margin-top: 18px;
          text-align: center;

        }
        .answer {
          margin-top: 30px;
          border-radius: 5px;
          border-width: 2px;
          border-color: #ffffff;
          border-style: dotted;
          box-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.09);
          width: 470px;
          padding: 10px 30px 10px 30px;
          cursor: pointer;
          font-family: PTSerif;
          color: #535353;
          font-size: 18px;
          font-weight: 400;
          line-height: 25px;
          text-align: left;
          &:hover {
            background: rgba(255, 255, 255, 0.15);
          }
        }
      }
      &.question-1 {
        background-image: url("/static/img/questions/question-1.jpg");
        background-position: top right;
        background-repeat: no-repeat;
      }
      &.question-2 {
        background-image: url("/static/img/questions/question-2.jpg");
        background-position: top right;
        background-repeat: no-repeat;
        .counter {
          color: white;
        }
        .question-text {
          color: white;
        }
        .answer {
          color: white;
        }
      }
      &.question-3 {
        background-color: #58e0c6;
        background-image: url("/static/img/questions/question-3.png");
        background-position: 92% center;
        background-repeat: no-repeat;
      }
      &.question-4 {
        background-color: #a0d77b;
        background-image: url("/static/img/questions/question-4.png");
        background-position: 96% center;
        background-repeat: no-repeat;
      }
      &.question-5 {
        background-color: #fc3f3f;
        background-image: url("/static/img/questions/question-5.png");
        background-position: 98% center;
        background-repeat: no-repeat;
        .counter {
          color: white;
        }
        .question-text {
          color: white;
        }
        .answer {
          color: white;
        }
      }
      &.question-6 {
        background-color: #ec8eaf;
        background-image: url("/static/img/questions/question-6.png");
        background-position: 98% center;
        background-repeat: no-repeat;
        .counter {
          color: white;
        }
        .question-text {
          color: white;
        }
        .answer {
          color: white;
        }
      }
      &.question-7 {
        background-color: #fbbdbd;
        background-image: url("/static/img/questions/question-7.png");
        background-position: 98% center;
        background-repeat: no-repeat;
      }
      &.question-8 {
        background-color: #4095b8;
        background-image: url("/static/img/questions/question-8.png");
        background-position: 98% top;
        background-repeat: no-repeat;
        .counter {
          color: white;
        }
        .question-text {
          color: white;
        }
        .answer {
          color: white;
        }
      }
      &.question-9 {
        background-color: #dbd23c;
        background-image: url("/static/img/questions/question-9.png");
        background-position: 98% top;
        background-repeat: no-repeat;
      }
      &.question-10 {
        background-color: #4eb840;
        background-image: url("/static/img/questions/question-10.png");
        background-position: 93% center;
        background-repeat: no-repeat;
        .counter {
          color: white;
        }
        .question-text {
          color: white;
        }
        .answer {
          color: white;
        }
      }
    }
  }

  .sharing {
    width: 180px;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    a {
      display: inline-flex;
      border-radius: 50%;
      border-width: 3px;
      border-color: #ff9908;
      border-style: solid;
      width: 35px;
      height: 35px;
      margin-right: 5px;
      margin-left: 5px;
      i {
        width: 40px;
        height: 35px;
        display: block;
        color: #ff9908;
        line-height: 32px;
        text-align: center;
      }
    }

  }

  .block-1 {
    margin: 0 auto;
    margin-top: 90px;
    width: 660px;

    h1 {
      font-family: PTSerif;
      color: #252525;
      font-size: 24px; /* Приближение из-за подстановки шрифтов */
      font-weight: 700;
      line-height: 34px; /* Приближение из-за подстановки шрифтов */
      text-align: left;
      &.center {
        margin-top: 20px;
        text-align: center;
      }
    }
    p {
      font-family: PTSerif;
      color: #252525;
      font-size: 18px; /* Приближение из-за подстановки шрифтов */
      font-weight: 400;
      line-height: 27px; /* Приближение из-за подстановки шрифтов */
      text-align: left;
      margin-top: 40px;
    }
    .muted {
      font-family: PTSans;
      color: #a39292;
      font-size: 16px; /* Приближение из-за подстановки шрифтов */
      font-weight: 400;
      line-height: 25.23px; /* Приближение из-за подстановки шрифтов */
      text-align: center;
      margin-top: 115px;

    }
    .w1 {
      width: 580px;
    }

  }

  .npf-container {
    margin-right: auto;
    margin-left: auto;
    padding-right: 15px;
    padding-left: 15px;
  }

  .faq {
    .faq-item {
      border-radius: 5px;
      border-width: 2px;
      border-color: #ebe4d8;
      border-style: dotted;
      width: 756px;
      margin: 40px auto;
      padding: 30px;
      transition: all ease-in-out 300ms;
      .text {
        margin-top: 20px;
        font-family: PTSerif;
        color: #252525;
        font-size: 18px; /* Приближение из-за подстановки шрифтов */
        font-weight: 400;
        line-height: 27px; /* Приближение из-за подстановки шрифтов */
        text-align: left;
        display: block;
        overflow: hidden;

      }
      &.collapsed {
        background-color: #f7f5f1;
        border: solid #f7f5f1 2px;
        .text {
          height: 0;
        }
      }

    }

  }

  .logo {
    display: block;
    margin: 100px auto;
    width: 240px;
  }

  @media screen and (max-width: 900px) {
    .desk {
      display: none !important;
    }
    .container {
      width: 100%;
      min-height: calc(100vmax - 57px);
      .intro-block {
        background-image: none;
        background: #abd83d;
        height: auto;
        .image-block {
          position: static;
          background-image: url("/static/img/mobile/index.jpg");
          background-size: contain;
          width: 100vw;
          height: 76vw;

          background-repeat: no-repeat;
        }
        .text-block {
          display: flex;
          flex-direction: column;
          width: 95vw;
          height: auto;
          margin: 0 auto;
          margin-bottom: 2.5vw;
          padding-bottom: 2.5vw;
          .muted {
            margin-top: 5px;

          }
          h1 {
            margin-top: 0;
          }
          p {
            font-size: 17px;
            font-weight: 400;
            line-height: 27px;
            text-align: center;
            margin-top: 5px;
          }

        }
      }
      .question-block {
        min-height: 100vh;
        background-size: auto 80vmin;
        background-position: top center;
        .question {
          width: 95vw;
          margin: 0 auto;
          margin-top: 47vmax;

          .counter {
            font-size: 13px;
            line-height: 13px;
          }
          .question-text {
            font-size: 18px;
            margin-top: 5px;
            line-height: normal;
          }
          .answer {
            width: 90vw;
            margin: 2vh auto;
            padding: 10px 5px;
            font-size: 15px;
            line-height: normal;
          }
        }

        &.question-1 {
          background-image: url("/static/img/mobile/question-1.jpg");
          background-position: top center;
        }
        &.question-2 {
          background-color: #004f9c;
          background-image: url("/static/img/questions/question-2.png");
          background-size: 80vmin;
          background-position: center 10vh;

        }
        &.question-3 {
          background-position: center 5vh;
          background-size: 60vmin;

        }
        &.question-4 {
          background-position: center 5vh;
          background-size: 60vmin;
          .question {
            margin-top: 40vmax;
          }

        }
        &.question-5 {
          background-position: center 5vh;
          background-size: 60vmin;
        }
        &.question-6 {
          background-position: center 5vh;
          background-size: 60vmin;
        }
        &.question-7 {
          background-position: center 5vh;
          background-size: 60vmin;
        }
        &.question-10 {
          background-position: center 5vh;
          background-size: 60vmin;
        }

      }
      .result-block {
        .result-intro {
          min-height: calc(100vmax - 57px);
          height: auto;
          padding-bottom: 20px;
          background-size: contain;
          .result-text {
            margin-top: 60vmin;
            .muted {
              margin-top: 10px;
            }
            h1 {
              margin-top: 10px;
            }
            p {
              margin-top: 5px;
            }
            .sharing {
              margin-top: 10px;
            }
            .arrow {
              margin-top: 10px;
            }
          }
        }
        &.result-1 {
          .result-intro {
            background-color: #571c2e;
            .result-text {
              margin-top: 60vmin;
            }

          }
        }
        &.result-3 {
          .result-intro {
            background-color: #a4cc48;;
            .result-text {
              margin-top: 63vmin;
            }

          }
        }
        &.result-2 {
          .result-intro {
            background-color: #ebe4d8;
            background-image: url("/static/img/mobile/result-2.png");
            background-position: center 5vh;
            .result-text {
              margin-top: 83vmin;
            }

          }
        }
        &.result-4 {
          .result-intro {
            .result-text {
              margin-top: 63vmin;
            }

          }
        }
      }

    }
    .block-1 {
      .w1 {
        width: 100%
      }
      width: 95vw;
    }
    .faq {
      .faq-item {
        width: 95vw;
        padding: 10px 15px;
      }
    }
  }

  @media screen and (max-width: 900px) and (orientation: landscape) {

    .result-text {
      margin-top: 40vmax !important;
    }

  }

  @media screen and (max-width: 370px) {
    .container {
      .intro-block {
        .text-block {
          h1 {
            font-size: 20px;
            font-weight: 700;
            line-height: 20.23px;
          }
          p {
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
          }
          button {
            margin-top: 10px;
          }
        }
      }
      .question-block {
        .question {
          .question-text {
            font-size: 16px;
          }
        }
      }
      .answer {
        width: 95vw !important;
        padding: 5px 5px !important;
      }
      .question-2 {
        .question {
          margin-top: 43vh !important;

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Quiz.vue